import z from "zod";

import { zStrOptionRole } from "../ZStrOptionRole";

const zAttrViewLongText = z.object({
  type: z.literal("LongText").describe("Для больших текстов"),
  maxHeight: z.number().describe("Макс. высота в пикселях"),
});
export type ZAttrViewLongText = z.infer<typeof zAttrViewLongText>;

const zAttrViewLink = z.object({
  type: z.literal("Link").describe("Внутренняя ссылка на страницу приложения"),
  role: zStrOptionRole.optional(),
});
export type ZAttrViewLink = z.infer<typeof zAttrViewLink>;

const zAttrViewImage = z.object({
  type: z.literal("Image").describe("Изображение (в том числе массив)"),
  maxWidth: z
    .number()
    .optional()
    .describe(
      "Максимально допустимая ширина выводимого изображения (в пикселях)",
    ),
  maxHeight: z
    .number()
    .optional()
    .describe(
      "Максимально допусимая высота выводимого изображения (в пикселях)",
    ),
});
export type ZAttrViewImage = z.infer<typeof zAttrViewImage>;

const zAttrViewFiles = z.object({
  type: z.literal("Files").describe("Файлы"),
});

export const zAttrViewComponent = z.discriminatedUnion("type", [
  zAttrViewLongText,
  zAttrViewLink,
  zAttrViewImage,
  zAttrViewFiles,
]);
export type ZAttrViewComponent = z.infer<typeof zAttrViewComponent>;
